export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_MARKETING_INDP_ADS",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_MARKETING_INDP_ADS",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_MARKETING_INDP_ADS",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_MARKETING_INDP_ADS",
  DESTROY_FORM: "DESTROY_FORM_MARKETING_INDP_ADS",
  SET_FORM_ERROR: "SET_FORM_ERROR_MARKETING_INDP_ADS",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_MARKETING_INDP_ADS",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_MARKETING_INDP_ADS",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_MARKETING_INDP_ADS",
  RESET_STATE: "RESET_STATE_MARKETING_INDP_ADS",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_MARKETING_INDP_ADS",
  REMOVE_OBJECT: "REMOVE_OBJECT_MARKETING_INDP_ADS",
  CLEAR_FETCHED: "CLEAR_FETCHED_MARKETING_INDP_ADS",

  ADD_MULTIPLE_INDPS: "ADD_MULTIPLE_INDPS_INDP_ADS",
  ADD_INDP: "ADD_INDP_INDP_ADS",
  REMOVE_INDP: "REMOVE_INDP_INDP_ADS",
  SET_ADS: "SET_ADS_INDP_ADS",
  SET_DEFAULT_SETTINGS: "SET_DEFAULT_SETTINGS_INDP_ADS",

  LIST_URL: "/market/ads/industrialpremisesad/list/",
  POST_URL: "/market/ads/industrialpremisesad/",
  PATCH_URL: "/market/ads/industrialpremisesad/",
  GET_URL: "/market/ads/industrialpremisesad/",

  STORE_NAME: "marketIndustrialPremisesAds",
};
